const encoder = new TextEncoder();
const decoder = new TextDecoder();
const resetScreen = '\x1b[2J\x1b[H';
const esc = String.fromCharCode(0x1b);
const fullScreenClearPattern = new RegExp(`${esc}(?:c|\\[(?:2|3)J)`, 'g');

export function terminalReplayText(bytes: Uint8Array): string {
  const text = decoder.decode(bytes);
  const clearIndex = lastScreenClearIndex(text);
  if (clearIndex <= 0) return text;
  return resetScreen + text.slice(clearIndex);
}

export function terminalReplayChunk(bytes: Uint8Array): { bytes: Uint8Array; resets: boolean } {
  const text = decoder.decode(bytes);
  const clearIndex = lastScreenClearIndex(text);
  if (clearIndex < 0) return { bytes, resets: false };
  return { bytes: encoder.encode(resetScreen + text.slice(clearIndex)), resets: true };
}

function lastScreenClearIndex(text: string): number {
  let clearIndex = -1;
  fullScreenClearPattern.lastIndex = 0;
  for (;;) {
    const match = fullScreenClearPattern.exec(text);
    if (!match) break;
    clearIndex = match.index;
  }
  return clearIndex;
}
